/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Prodesc1Inputs */

const zh_plan_prodesc1 = /** @type {(inputs: Plan_Prodesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合进阶用户，解锁全部功能`)
};

const en_plan_prodesc1 = /** @type {(inputs: Plan_Prodesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For power users who want everything`)
};

const es_plan_prodesc1 = /** @type {(inputs: Plan_Prodesc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para usuarios avanzados que quieren todo`)
};

/**
* | output |
* | --- |
* | "For power users who want everything" |
*
* @param {Plan_Prodesc1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_prodesc1 = /** @type {((inputs?: Plan_Prodesc1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Prodesc1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_prodesc1(inputs)
	if (locale === "en") return en_plan_prodesc1(inputs)
	return es_plan_prodesc1(inputs)
});
export { plan_prodesc1 as "plan_proDesc" }